import React from 'react';
import { useSelector } from 'react-redux';

import MaxWidth from '@/components/common/layout/MaxWidth';
import FeatureItem from '@/components/route/listing/Features/FeatureItem';
import { ELocationDetails, LOCATION_DETAILS_ICONS } from '@/constants/locationDetails';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { getCampgroundLocationDetails } from '@/redux/selectors/campgrounds/page';
// import { getCampgroundAmenities } from '@/redux/selectors/listing/amenities';

// import { AmenitiesModal } from './AmenitiesModal';

export const Amenities = () => {
  const { isMobile } = useBreakpoint();
  const locationDetails = useSelector(getCampgroundLocationDetails);
  // const amenities = useSelector(getCampgroundAmenities);
  // const { list: amenitiesList, categories: amenitiesCategories } = amenities;

  const { sceneries: sceneryDetails, activities: activitiesDetails } = locationDetails || {};

  const activitiesSliceEnd =
    (sceneryDetails?.length || 0) >= 4 ? 3 : 7 - (sceneryDetails?.length || 0);

  const items = [
    ...(sceneryDetails || []).slice(0, isMobile ? 2 : 4),
    ...(activitiesDetails || []).slice(0, isMobile ? 2 : activitiesSliceEnd),
  ];

  const gridCols = isMobile
    ? 'repeat(2, minmax(0, 1fr))'
    : `repeat(${Math.max(items.length, 1)}, minmax(0, 1fr))`;

  return (
    <section className="pb-8 md:pb-12">
      <MaxWidth className="mx-auto gap-8 md:gap-12">
        <div className="flex flex-col mt-6 md:items-center md:mt-10 gap-6">
          <ul
            className="text-center grid md:gap-8 gap-y-4"
            style={{ gridTemplateColumns: gridCols }}>
            {items.map(item => (
              <li key={item.type} className="text-base font-normal text-primary-base semiHighlight">
                <FeatureItem
                  BonfireIcon={LOCATION_DETAILS_ICONS[item.type as ELocationDetails]}
                  label={item.label}
                  direction={isMobile ? 'row' : 'column'}
                />
              </li>
            ))}
          </ul>

          {/* <AmenitiesModal amenitiesList={amenitiesList} categories={amenitiesCategories} /> */}
        </div>
      </MaxWidth>
    </section>
  );
};
